import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import {
  PRIMARY_CONTACT,
  buildWhatsAppMessage,
  buildWhatsAppUrl,
} from "@/lib/company";

export default function FloatingWhatsApp() {
  const [open, setOpen] = useState(false);
  const [pulse, setPulse] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setPulse(false), 6000);
    return () => clearTimeout(t);
  }, []);

  const url = buildWhatsAppUrl(buildWhatsAppMessage());

  return (
    <div
      data-testid="floating-whatsapp"
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[60]"
    >
      {open && (
        <div
          data-testid="whatsapp-card"
          className="mb-3 w-[300px] bg-[#0A1120] border border-[#1E293B] shadow-2xl shadow-black/60 animate-in"
        >
          <div className="flex items-center justify-between bg-[#111C30] px-4 py-3 border-b border-[#1E293B]">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-[#25D366] flex items-center justify-center">
                <MessageCircle size={18} className="text-white" />
              </div>
              <div>
                <div className="text-white font-bold text-sm leading-none">
                  {PRIMARY_CONTACT.name}
                </div>
                <div className="text-[10px] tracking-wider uppercase text-[#22C55E] mt-1">
                  ● Online
                </div>
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              data-testid="whatsapp-close"
              className="text-slate-500 hover:text-white"
              aria-label="Chiudi"
            >
              <X size={18} />
            </button>
          </div>
          <div className="p-4">
            <div className="bg-[#111C30] p-3 mb-3 text-sm text-slate-300 leading-relaxed">
              Ciao! Sono Denny di Dea srl. Compila il questionario e ti
              richiamiamo per fissare il sopralluogo gratuito.
            </div>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-start-btn"
              className="block bg-[#25D366] hover:bg-[#1FBA56] text-white text-center font-semibold py-3 text-sm transition-colors"
            >
              Apri chat WhatsApp
            </a>
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        data-testid="whatsapp-toggle"
        className="relative w-14 h-14 md:w-16 md:h-16 bg-[#25D366] hover:bg-[#1FBA56] text-white flex items-center justify-center shadow-2xl shadow-[#25D366]/40 transition-colors"
        aria-label="Apri chat WhatsApp"
      >
        {pulse && (
          <span className="absolute inset-0 bg-[#25D366] animate-ping opacity-60" />
        )}
        <MessageCircle size={26} strokeWidth={2} className="relative" />
      </button>
    </div>
  );
}
